import React from "react";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import DashboardContainer from "../components/dashboard/DashboardContainer";

/**
 * Default view is a smart component that renders the default
 * page following redirection of a logged-in user.
 */
const useStyles = makeStyles({
  root: {
    display: "flex",
    minHeight: "70vh"
  },
  inner: {
    textAlign: "center",
    justifyContent: "center",
    alignItems: "center"
  }
});

const DashboardView: React.FC = () => {
  const classes = useStyles();
  return (
    <Grid
      container
      className={classes.root}
      justify="center"
      alignItems="center"
    >
      <Grid item xs={6} className={classes.inner}>
        <DashboardContainer />
      </Grid>
    </Grid>
  );
};

export default DashboardView;
